import { render, staticRenderFns } from "./MultipleChoiceInput.vue?vue&type=template&id=2259b74c&scoped=true&"
import script from "./MultipleChoiceInput.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceInput.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceInput.vue?vue&type=style&index=0&id=2259b74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259b74c",
  null
  
)

export default component.exports